import { Crown, Zap, Star, User } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useFreeMode } from '@/hooks/useFreeMode';

export const PlanBadge = () => {
  const { profile } = useAuth();
  const { freeMode } = useFreeMode();
  
  // Hide completely in free mode
  if (freeMode) {
    return null;
  }
  
  const planConfig = {
    free: { 
      label: 'Free', 
      icon: User, 
      className: 'bg-muted text-muted-foreground border-muted' 
    },
    ghost: { 
      label: 'Ghost', 
      icon: Zap, 
      className: 'bg-info/10 text-info border-info/30' 
    },
    phantom: { 
      label: 'Phantom', 
      icon: Star, 
      className: 'bg-accent/10 text-accent border-accent/30' 
    },
    elite: { 
      label: 'Elite', 
      icon: Crown, 
      className: 'bg-primary/10 text-primary border-primary/30' 
    },
  };

  const plan = profile?.plan || 'free';
  const config = planConfig[plan as keyof typeof planConfig] || planConfig.free;
  const Icon = config.icon;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium border ${config.className}`}>
      <Icon className="w-3 h-3" />
      <span>{config.label}</span>
    </div>
  );
};
